import { render, staticRenderFns } from "./PermissionsDocumentsForm.vue?vue&type=template&id=3239237a&scoped=true&"
import script from "./PermissionsDocumentsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsDocumentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3239237a",
  null
  
)

export default component.exports